import Cookies from 'js-cookie';
import { Base64 } from 'js-base64';

const trackDelay    = 1000;//;
const debounceDelay = 5;//;
const UID           = Cookies.get('ngx_uid');

let checkInfinityScroll = 0;

const init = (instance) => {
    return setTimeout(() => {

        debug(`Start scroll tracking for Article id ${instance.id}`);

        track(instance);
        bind(instance);

        return instance;
    }, trackDelay);
};

const bind = (instance) => {
    window.addEventListener('scroll', () => {
        track(instance);
    }, false);
    window.addEventListener('resize', () => {
        track(instance);
    }, false);
};

const track = (instance) => {
    if (instance.timer !== null) {
        clearTimeout(instance.timer);
    }

    instance.timer = setTimeout(() => {
        instance.getDimensions();
        instance.getCurrentPosition();
    }, debounceDelay);
};

const vestiCounter = (instance) => {
    let $imageMH = new Image();
    let hashMH   = {
        id:      instance.id,
        type:    'article',
        ngx_uid: UID
    };

    $imageMH.src = `https://pics.vesti.ru/counter/video_counter.gif?mh_${Base64.encode(JSON.stringify(hashMH))}`;

    // instance.$el.appendChild($imageMH);
};

const piwikPush = (id) => {

    debug('Send PIWIK');

    _paq.push(['setTrackerUrl', 'https://vstat.rtr-vesti.ru/']);
    _paq.push(['setUserId', UID]);
    _paq.push([
        'trackEvent',
        'article',
        'thirdQuartile',
        '/article_id/' + id + '/sid/vesti',
        UID
    ]);
};

const getArticleId = (elementId) => +elementId.replace(/(.+?)(\d.+)/ig, '$2');

const debug = (message) => {
    if (window.location.origin.match(/\.dev\.rfn\.ru/)) {
        console.log(message);
    }
};

export default class VgtrkScrollTrack {
    constructor($block, type) {

        this.$el   = $block || document.querySelector('.article');
        this.id    = $block.classList.contains('article')
            ? $block.getAttribute('data-id')
            : getArticleId(this.$el.querySelector('.article').id);
        this.type  = type;
        this.marks = {
            half:         false,
            threeQuarter: false,
            full:         false
        };

        this.timer = null;

        this.breakpoints = {};

        return this.$el ? init(this) : null;
    }

    getDimensions() {
        this.height = this.$el.offsetHeight;
        this.offset = this.$el.offsetTop;

        this.breakpoints.half         = this.height / 2 + this.offset;
        this.breakpoints.threeQuarter = this.height / 4 * 3 + this.offset;
        this.breakpoints.full         = this.height - (window.innerHeight / 2) + this.offset;
    };

    getCurrentPosition() {
        let scrollPosition = window.scrollY || window.pageYOffset;
        let scrollCenter   = scrollPosition + (window.innerHeight / 2);

        if (!this.marks.half && scrollCenter >= this.breakpoints.half && scrollCenter < this.breakpoints.threeQuarter) {
            debug('> 50% of article was scrolled');
            this.marks.half = true;
            if ('gtag' in window) {
                gtag('event', 'scroll', {
                    event_category: 'pageview',
                    event_label:    this.type,
                    value:          50
                });
            }
        }

        if (!this.marks.threeQuarter && scrollCenter >= this.breakpoints.threeQuarter && scrollCenter < this.breakpoints.full) {
            debug('> 75% of article was scrolled');
            this.marks.half         = true;
            this.marks.threeQuarter = true;
            if ('gtag' in window) {
                gtag('event', 'scroll', {
                    event_category: 'pageview',
                    event_label:    this.type,
                    value:          75
                });
            }

            vestiCounter(this);
            piwikPush(this.id);
        }

        if (!this.marks.full && scrollCenter >= this.breakpoints.full) {

            checkInfinityScroll++;
            if (checkInfinityScroll > 1) {
                let url = '/'+this.type+'/'+this.id+'/';
                ym(21374125, 'hit', url);
                ym(55382026, 'hit', url);
                ym(21374125,'reachGoal','depth_test');
            }

            debug('100% of article was scrolled');
            this.marks.half         = true;
            this.marks.threeQuarter = true;
            this.marks.full         = true;
            if ('gtag' in window) {
                gtag('event', 'scroll', {
                    event_category: 'pageview',
                    event_label:    this.type,
                    value:          100
                });
            }

            // if ('ym' in window) {
            //     ym(21374125, 'reachGoal', 'scroll')
            //     ym(55382026, 'reachGoal', 'scroll')
            // }
        }
    }

}
